import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Skeleton } from '@uhg-abyss/web/ui/Skeleton';

type Props = {
  index: number;
};

export const AllFilterSkeleton = ({ index }: Props) => (
  <Accordion.Item key={index} value={`${index}`}>
    <Flex justify="space-between">
      <Skeleton height={10} variant="alternate" width={200} />{' '}
      <Skeleton height={10} variant="alternate" width={50} />
    </Flex>
  </Accordion.Item>
);
